import { render } from "./UsdtPaymentPage.vue?vue&type=template&id=37bd0b70&scoped=true"
import script from "./UsdtPaymentPage.vue?vue&type=script&lang=js"
export * from "./UsdtPaymentPage.vue?vue&type=script&lang=js"

import "./UsdtPaymentPage.vue?vue&type=style&index=0&id=37bd0b70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bd0b70"]])

export default __exports__